export default __webpack_public_path__ + "static/media/(Low Res) JD Reception-012_tn.d0ae6f0f.jpg";